import * as React from 'react';

const ChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 13.586L16.293 9.293C16.683 8.903 17.317 8.903 17.707 9.293C18.097 9.683 18.097 10.317 17.707 10.707L12.707 15.707C12.317 16.097 11.683 16.097 11.293 15.707L6.29299 10.707C5.90299 10.317 5.90299 9.683 6.29299 9.293C6.68299 8.903 7.31699 8.903 7.70699 9.293L12 13.586Z" fill="currentColor"/>
  </svg>
);

export default ChevronDown;
